export const defaultGeneralInfoValues = {
  vietnameseName: '',
  englishName: '',
  projectType: '',
  projectProposalResearchFields: [],
  recommendedExperts: [],
  researchType: {},
  implementationMonths: '',
  totalExpenditure: '',
  nationalUniversityTotalExpenditure: '',
  nationalUniversityAllocatedExpenditure: '',
  nationalUniversityNonallocatedExpenditure: '',
  fundingExpenditure: '',
  fundingExpenditureSelf: '',
  fundingExpenditureSelfFileUrl: '',
  fundingExpenditureOther: '',
  fundingExpenditureOtherFileUrl: '',
  otherSponsorOrganization: '',
  projectProposalOrganizations: [],
  projectProposalContacts: [],
};

export const defaultResearchResultValues = {
  softProducts: [],
  hardProducts: [],
  qualityComparison: '',
  projectProposalResearchKpis: [],
};

export const defaultExpenditureValues = {
  proposedExpenditureSummaries: [],
};

export const defaultDocumentsValues = {
  researchDescriptionFileUrl: '',
  expenditureFileUrl: '',
};

export const defaultProjecProposalsFilters = {
  vietnameseName: '',
  projectType: [],
  ownerName: '',
  organizationId: [],
  researchFieldId: [],
  researchTypeId: [],
  totalExpenditure: { min: undefined, max: undefined },
  programId: [],
  submittedAt: { start: '', end: '' },
  councilTypeId: [],
  statusName: ['submit', 'approved'],
};

export const defaultProjectFilters = {
  vietnameseName: '',
  ownerName: '',
  organizationId: [],
  programId: [],
  totalExpenditure: { min: undefined, max: undefined },
  signedAt: { start: '', end: '' },
  projectStatus: [],
};
